import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePageOne from "./pages/HomePageOne";
import HomePageTwo from "./pages/HomePageTwo";
import HomePageThree from "./pages/HomePageThree";
import HomePageFour from "./pages/HomePageFour";
import HomePageFive from "./pages/HomePageFive";
import HomePageSix from "./pages/HomePageSix";
import HomePageSeven from "./pages/HomePageSeven";
import EmailPage from "./pages/EmailPage";
import AddUserPage from "./pages/AddUserPage";
import AlertPage from "./pages/AlertPage";
import AssignRolePage from "./pages/AssignRolePage";
import AvatarPage from "./pages/AvatarPage";
import BadgesPage from "./pages/BadgesPage";
import ButtonPage from "./pages/ButtonPage";
import CalendarMainPage from "./pages/CalendarMainPage";
import CardPage from "./pages/CardPage";
import CarouselPage from "./pages/CarouselPage";
import ChatEmptyPage from "./pages/ChatEmptyPage";
import ChatMessagePage from "./pages/ChatMessagePage";
import ChatProfilePage from "./pages/ChatProfilePage";
import CodeGeneratorNewPage from "./pages/CodeGeneratorNewPage";
import CodeGeneratorPage from "./pages/CodeGeneratorPage";
import ColorsPage from "./pages/ColorsPage";
import ColumnChartPage from "./pages/ColumnChartPage";
import CompanyPage from "./pages/CompanyPage";
import CurrenciesPage from "./pages/CurrenciesPage";
import DropdownPage from "./pages/DropdownPage";
import ErrorPage from "./pages/ErrorPage";
import FaqPage from "./pages/FaqPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import FormLayoutPage from "./pages/FormLayoutPage";
import FormValidationPage from "./pages/FormValidationPage";
import FormPage from "./pages/FormPage";
import GalleryPage from "./pages/GalleryPage";
import ImageGeneratorPage from "./pages/ImageGeneratorPage";
import ImageUploadPage from "./pages/ImageUploadPage";
import InvoiceAddPage from "./pages/InvoiceAddPage";
import InvoiceEditPage from "./pages/InvoiceEditPage";
import InvoiceListPage from "./pages/InvoiceListPage";
import InvoicePreviewPage from "./pages/InvoicePreviewPage";
import KanbanPage from "./pages/KanbanPage";
import LanguagePage from "./pages/LanguagePage";
import LineChartPage from "./pages/LineChartPage";
import ListPage from "./pages/ListPage";
import MarketplaceDetailsPage from "./pages/MarketplaceDetailsPage";
import MarketplacePage from "./pages/MarketplacePage";
import NotificationAlertPage from "./pages/NotificationAlertPage";
import NotificationPage from "./pages/NotificationPage";
import PaginationPage from "./pages/PaginationPage";
import PaymentGatewayPage from "./pages/PaymentGatewayPage";
import PieChartPage from "./pages/PieChartPage";
import PortfolioPage from "./pages/PortfolioPage";
import PricingPage from "./pages/PricingPage";
import ProgressPage from "./pages/ProgressPage";
import RadioPage from "./pages/RadioPage";
import RoleAccessPage from "./pages/RoleAccessPage";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import StarRatingPage from "./pages/StarRatingPage";
import StarredPage from "./pages/StarredPage";
import SwitchPage from "./pages/SwitchPage";
import TableBasicPage from "./pages/TableBasicPage";
import TableDataPage from "./pages/TableDataPage";
import TabsPage from "./pages/TabsPage";
import TagsPage from "./pages/TagsPage";
import TermsConditionPage from "./pages/TermsConditionPage";
import TextGeneratorPage from "./pages/TextGeneratorPage";
import ThemePage from "./pages/ThemePage";
import TooltipPage from "./pages/TooltipPage";
import TypographyPage from "./pages/TypographyPage";
import UsersGridPage from "./pages/UsersGridPage";
import UsersListPage from "./pages/UsersListPage";
import ViewDetailsPage from "./pages/ViewDetailsPage";
import VideoGeneratorPage from "./pages/VideoGeneratorPage";
import VideosPage from "./pages/VideosPage";
import ViewProfilePage from "./pages/ViewProfilePage";
import VoiceGeneratorPage from "./pages/VoiceGeneratorPage";
import WalletPage from "./pages/WalletPage";
import WidgetsPage from "./pages/WidgetsPage";
import WizardPage from "./pages/WizardPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import TextGeneratorNewPage from "./pages/TextGeneratorNewPage";
import HomePageEight from "./pages/HomePageEight";
import HomePageNine from "./pages/HomePageNine";
import HomePageTen from "./pages/HomePageTen";
import HomePageEleven from "./pages/HomePageEleven";
import GalleryGridPage from "./pages/GalleryGridPage";
import GalleryMasonryPage from "./pages/GalleryMasonryPage";
import GalleryHoverPage from "./pages/GalleryHoverPage";
import BlogPage from "./pages/BlogPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import AddBlogPage from "./pages/AddBlogPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import ComingSoonPage from "./pages/ComingSoonPage";
import AccessDeniedPage from "./pages/AccessDeniedPage";
import MaintenancePage from "./pages/MaintenancePage";
import BlankPagePage from "./pages/BlankPagePage";
import PublicRoute from "./RouteComp/PublicRoute";
import PrivateRoute from "./RouteComp/PrivateRoute";
import CategoryManagement from "./pages/CategoryManagement/CategoryManagement";
import SubCategoriesManagement from "./pages/CategoryManagement/SubCategoriesManagement";
import AddNewCategoryPage from "./pages/CategoryManagement/AddNewCategoryPage";
import AddNewSubCategoryPage from "./pages/CategoryManagement/AddNewSubCategoryPage";
import EmailTemplatesPage from "./pages/EmailTemplates/EmailTemplatesPage";
import AddTemplatePage from "./pages/EmailTemplates/AddTemplatePage";
import PackageSizes from "./pages/PackageSizes/PackageSizes";
import AddPackage from "./components/PackageSizes/AddPackage";
import AddPackagePage from "./pages/PackageSizes/AddPackagePage";
import InsuranceChargesPage from "./pages/InsuranceCharges/InsuranceChargesPage";
import ShipmentChargesPage from "./pages/ShipmentChargesPage/ShipmentChargesPage";
import AddShipCharges from "./components/ShipmentCharges/AddShipCharges";
import AddShipChargesPage from "./pages/ShipmentChargesPage/AddShipChargesPage";
import UpdateShipChargesPage from "./pages/ShipmentChargesPage/UpdateShipChargesPage";
import ShipmentDuration from "./pages/ShipmentDuration/ShipmentDuration";
import ShipmentCalculatorPage from "./pages/ShipmentCalculator/ShipmentCalculatorPage";
import CreateShipTypeDurationPage from "./pages/ShipmentDuration/CreateShipTypeDurationPage";
import AddShipPackagePage from "./pages/ShipmentCalculator/AddShipPackagePage";
import ShipmentEnquiriesPage from "./pages/ShipmentEnquiries/ShipmentEnquiriesPage";
import AddFollowUpPage from "./pages/ShipmentEnquiries/AddFollowUpPage";

import OrderManagement from "./pages/OrderManagement/OrderManagement";
import UmbrellaManagementPage from "./pages/UmbrellaManagement/UmbrellaManagementPage";
import AddUmbrellaPage from "./pages/UmbrellaManagement/AddUmbrellaPage";
import DashboardPage from "./pages/DashboardV2/DashboardPage";
import DashboardPage1 from "./pages/Dashboard/DashboardPage1";
import AddOrderPage from "./pages/OrderManagement/AddOrderPage";
import WarehouseAddressPage from "./pages/WarehouseAddress/WarehouseAddressPage";
import CouponsManagementPage from "./pages/CouponsManagement/CouponsManagementPage";
import CreateCouponsPage from "./pages/CouponsManagement/CreateCouponsPage";
import CustomersPage from "./pages/Customers/CustomersPage";
import CreateCustomersPage from "./pages/Customers/CreateCustomersPage";
import { useEffect } from "react";
import UserVerification from "./pages/UserVerification/UserVerification";
import Payments from "./pages/Payments/Payments";
import EditCustomerPage from "./pages/Customers/EditCustomerPage";
import { loadGoogleTranslate } from "./helper/googleTranslate";

function App() {




  return (
    <>

      <div id="google_translate_element" style={{ display: 'none' }} />


      <RouteScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <PrivateRoute>
              <DashboardPage />
            </PrivateRoute>
          }
        />





        <Route
          exact
          path='/sign-in'
          element={
            <PublicRoute>
              <SignInPage />
            </PublicRoute>
          }
        />

        <Route path="/categories" element={<PrivateRoute><CategoryManagement /></PrivateRoute>} />
        <Route path="/sub-categories" element={<PrivateRoute><SubCategoriesManagement /></PrivateRoute>} />
        <Route path="/add-category" element={<PrivateRoute><AddNewCategoryPage /></PrivateRoute>} />
        <Route path="/add-sub-category" element={<PrivateRoute><AddNewSubCategoryPage /></PrivateRoute>} />
        <Route path="/email-templates" element={<PrivateRoute><EmailTemplatesPage /></PrivateRoute>} />
        <Route path="/add-email-templates" element={<PrivateRoute><AddTemplatePage /></PrivateRoute>} />
        <Route path="/add-package" element={<PrivateRoute><AddPackagePage /></PrivateRoute>} />
        {/* <Route path="/add-package/:id" element={<AddPackagePage />} /> */}


        <Route path="/package-sizes" element={<PrivateRoute><PackageSizes /></PrivateRoute>} />
        <Route path="/insurance-charges" element={<PrivateRoute><InsuranceChargesPage /></PrivateRoute>} />
        <Route path="/shipment-charges" element={<PrivateRoute><ShipmentChargesPage /></PrivateRoute>} />
        <Route path="/add-ship-charges" element={<PrivateRoute><AddShipChargesPage /></PrivateRoute>} />
        <Route path="/update-ship-charges" element={<PrivateRoute><UpdateShipChargesPage /></PrivateRoute>} />

        {/* <Route path="/add-ship-charges/:id" element={<AddShipChargesPage />} /> */}


        <Route path="/shipment-duration" element={<PrivateRoute><ShipmentDuration /></PrivateRoute>} />
        <Route path="/create-shipment-duration" element={<PrivateRoute><CreateShipTypeDurationPage /></PrivateRoute>} />






        <Route path="/shipment-calculator" element={<PrivateRoute><ShipmentCalculatorPage /></PrivateRoute>} />
        <Route path="/add-shipment-package" element={<PrivateRoute><AddShipPackagePage /></PrivateRoute>} />


        <Route path="/shipment-enquiry" element={<PrivateRoute><ShipmentEnquiriesPage /></PrivateRoute>} />
        <Route path="/add-follow-up" element={<PrivateRoute><AddFollowUpPage /></PrivateRoute>} />



        <Route path="/order-management" element={<PrivateRoute><OrderManagement /></PrivateRoute>} />

        <Route path="/payments" element={<PrivateRoute><Payments /></PrivateRoute>} />

        <Route path="/add-order" element={<PrivateRoute><AddOrderPage /></PrivateRoute>} />



        <Route path="/umbrella-managemnt" element={<PrivateRoute><UmbrellaManagementPage /></PrivateRoute>} />
        <Route path="/add-umbrella" element={<PrivateRoute><AddUmbrellaPage /></PrivateRoute>} />
        
        {/* <Route path="/add-order" element={< />} /> */}









        <Route path="/warehouse-address" element={<PrivateRoute><WarehouseAddressPage /></PrivateRoute>} />


        <Route path="/coupons-management" element={<PrivateRoute><CouponsManagementPage /></PrivateRoute>} />
        <Route path="/customers" element={<PrivateRoute><CustomersPage /></PrivateRoute>} />

        <Route path="/create-coupons" element={<PrivateRoute><CreateCouponsPage /></PrivateRoute>} />
        <Route path="/create-users" element={<PrivateRoute><CreateCustomersPage /></PrivateRoute>} />
        <Route path="/edit-users" element={<PrivateRoute><EditCustomerPage /></PrivateRoute>} />

        <Route path="/verify-user/:slug" element={<PrivateRoute><UserVerification /></PrivateRoute>} />





























        <Route exact path='/index-2' element={<PrivateRoute><HomePageTwo /></PrivateRoute>} />
        <Route exact path='/index-3' element={<PrivateRoute><HomePageThree /></PrivateRoute>} />
        <Route exact path='/index-4' element={<PrivateRoute><HomePageFour /></PrivateRoute>} />
        <Route exact path='/index-5' element={<PrivateRoute><HomePageFive /></PrivateRoute>} />
        <Route exact path='/index-6' element={<PrivateRoute><HomePageSix /></PrivateRoute>} />
        <Route exact path='/index-7' element={<PrivateRoute><HomePageSeven /></PrivateRoute>} />
        <Route exact path='/index-8' element={<PrivateRoute><HomePageEight /></PrivateRoute>} />
        <Route exact path='/index-9' element={<PrivateRoute><HomePageNine /></PrivateRoute>} />
        <Route exact path='/index-10' element={<PrivateRoute><HomePageTen /></PrivateRoute>} />
        <Route exact path='/index-11' element={<PrivateRoute><HomePageEleven /></PrivateRoute>} />

        {/* SL */}
        <Route exact path='/add-user' element={<PrivateRoute><AddUserPage /></PrivateRoute>} />
        <Route exact path='/alert' element={<PrivateRoute><AlertPage /></PrivateRoute>} />
        <Route exact path='/assign-role' element={<PrivateRoute><AssignRolePage /></PrivateRoute>} />
        <Route exact path='/avatar' element={<PrivateRoute><AvatarPage /></PrivateRoute>} />
        <Route exact path='/badges' element={<PrivateRoute><BadgesPage /></PrivateRoute>} />
        <Route exact path='/button' element={<PrivateRoute><ButtonPage /></PrivateRoute>} />
        <Route exact path='/calendar-main' element={<PrivateRoute><CalendarMainPage /></PrivateRoute>} />
        <Route exact path='/calendar' element={<PrivateRoute><CalendarMainPage /></PrivateRoute>} />
        <Route exact path='/card' element={<PrivateRoute><CardPage /></PrivateRoute>} />
        <Route exact path='/carousel' element={<PrivateRoute><CarouselPage /></PrivateRoute>} />
        <Route exact path='/chat-empty' element={<PrivateRoute><ChatEmptyPage /></PrivateRoute>} />
        <Route exact path='/chat-message' element={<PrivateRoute><ChatMessagePage /></PrivateRoute>} />
        <Route exact path='/chat-profile' element={<PrivateRoute><ChatProfilePage /></PrivateRoute>} />
        <Route exact path='/code-generator' element={<PrivateRoute><CodeGeneratorPage /></PrivateRoute>} />
        <Route
          exact
          path='/code-generator-new'
          element={<PrivateRoute><CodeGeneratorNewPage /></PrivateRoute>}
        />
        <Route exact path='/colors' element={<PrivateRoute><ColorsPage /></PrivateRoute>} />
        <Route exact path='/column-chart' element={<PrivateRoute><ColumnChartPage /></PrivateRoute>} />
        <Route exact path='/company' element={<PrivateRoute><CompanyPage /></PrivateRoute>} />
        <Route exact path='/currencies' element={<PrivateRoute><CurrenciesPage /></PrivateRoute>} />
        <Route exact path='/dropdown' element={<PrivateRoute><DropdownPage /></PrivateRoute>} />
        <Route exact path='/email' element={<PrivateRoute><EmailPage /></PrivateRoute>} />
        <Route exact path='/faq' element={<PrivateRoute><FaqPage /></PrivateRoute>} />
        <Route exact path='/forgot-password' element={<PrivateRoute><ForgotPasswordPage /></PrivateRoute>} />
        <Route exact path='/form-layout' element={<PrivateRoute><FormLayoutPage /></PrivateRoute>} />
        <Route exact path='/form-validation' element={<PrivateRoute><FormValidationPage /></PrivateRoute>} />
        <Route exact path='/form' element={<PrivateRoute><FormPage /></PrivateRoute>} />

        <Route exact path='/gallery' element={<PrivateRoute><GalleryPage /></PrivateRoute>} />
        <Route exact path='/gallery-grid' element={<PrivateRoute><GalleryGridPage /></PrivateRoute>} />
        <Route exact path='/gallery-masonry' element={<PrivateRoute><GalleryMasonryPage /></PrivateRoute>} />
        <Route exact path='/gallery-hover' element={<PrivateRoute><GalleryHoverPage /></PrivateRoute>} />

        <Route exact path='/blog' element={<PrivateRoute><BlogPage /></PrivateRoute>} />
        <Route exact path='/blog-details' element={<PrivateRoute><BlogDetailsPage /></PrivateRoute>} />
        <Route exact path='/add-blog' element={<PrivateRoute><AddBlogPage /></PrivateRoute>} />

        <Route exact path='/testimonials' element={<PrivateRoute><TestimonialsPage /></PrivateRoute>} />
        <Route exact path='/coming-soon' element={<PrivateRoute><ComingSoonPage /></PrivateRoute>} />
        <Route exact path='/access-denied' element={<PrivateRoute><AccessDeniedPage /></PrivateRoute>} />
        <Route exact path='/maintenance' element={<PrivateRoute><MaintenancePage /></PrivateRoute>} />
        <Route exact path='/blank-page' element={<PrivateRoute><BlankPagePage /></PrivateRoute>} />

        <Route exact path='/image-generator' element={<PrivateRoute><ImageGeneratorPage /></PrivateRoute>} />
        <Route exact path='/image-upload' element={<PrivateRoute><ImageUploadPage /></PrivateRoute>} />
        <Route exact path='/invoice-add' element={<PrivateRoute><InvoiceAddPage /></PrivateRoute>} />
        <Route exact path='/invoice-edit' element={<PrivateRoute><InvoiceEditPage /></PrivateRoute>} />
        <Route exact path='/invoice-list' element={<PrivateRoute><InvoiceListPage /></PrivateRoute>} />
        <Route exact path='/invoice-preview' element={<PrivateRoute><InvoicePreviewPage /></PrivateRoute>} />
        <Route exact path='/kanban' element={<PrivateRoute><KanbanPage /></PrivateRoute>} />
        <Route exact path='/language' element={<PrivateRoute><LanguagePage /></PrivateRoute>} />
        <Route exact path='/line-chart' element={<PrivateRoute><LineChartPage /></PrivateRoute>} />
        <Route exact path='/list' element={<PrivateRoute><ListPage /></PrivateRoute>} />
        <Route
          exact
          path='/marketplace-details'
          element={<PrivateRoute><MarketplaceDetailsPage /></PrivateRoute>}
        />
        <Route exact path='/marketplace' element={<PrivateRoute><MarketplacePage /></PrivateRoute>} />
        <Route
          exact
          path='/notification-alert'
          element={<PrivateRoute><NotificationAlertPage /></PrivateRoute>}
        />
        <Route exact path='/notification' element={<PrivateRoute><NotificationPage /></PrivateRoute>} />
        <Route exact path='/pagination' element={<PrivateRoute><PaginationPage /></PrivateRoute>} />
        <Route exact path='/payment-gateway' element={<PrivateRoute><PaymentGatewayPage /></PrivateRoute>} />
        <Route exact path='/pie-chart' element={<PrivateRoute><PieChartPage /></PrivateRoute>} />
        <Route exact path='/portfolio' element={<PrivateRoute><PortfolioPage /></PrivateRoute>} />
        <Route exact path='/pricing' element={<PrivateRoute><PricingPage /></PrivateRoute>} />
        <Route exact path='/progress' element={<PrivateRoute><ProgressPage /></PrivateRoute>} />
        <Route exact path='/radio' element={<PrivateRoute><RadioPage /></PrivateRoute>} />
        <Route exact path='/role-access' element={<PrivateRoute><RoleAccessPage /></PrivateRoute>} />


        <Route exact path='/sign-up' element={<SignUpPage />} />
        <Route exact path='/star-rating' element={<StarRatingPage />} />
        <Route exact path='/starred' element={<StarredPage />} />
        <Route exact path='/switch' element={<SwitchPage />} />
        <Route exact path='/table-basic' element={<TableBasicPage />} />
        <Route exact path='/table-data' element={<TableDataPage />} />
        <Route exact path='/tabs' element={<TabsPage />} />
        <Route exact path='/tags' element={<TagsPage />} />
        <Route exact path='/terms-condition' element={<TermsConditionPage />} />
        <Route
          exact
          path='/text-generator-new'
          element={<TextGeneratorNewPage />}
        />
        <Route exact path='/text-generator' element={<TextGeneratorPage />} />
        <Route exact path='/theme' element={<ThemePage />} />
        <Route exact path='/tooltip' element={<TooltipPage />} />
        <Route exact path='/typography' element={<TypographyPage />} />
        <Route exact path='/users-grid' element={<UsersGridPage />} />
        <Route exact path='/users-list' element={<UsersListPage />} />
        <Route exact path='/view-details' element={<ViewDetailsPage />} />
        <Route exact path='/video-generator' element={<VideoGeneratorPage />} />
        <Route exact path='/videos' element={<VideosPage />} />
        <Route exact path='/view-profile' element={<ViewProfilePage />} />
        <Route exact path='/voice-generator' element={<VoiceGeneratorPage />} />
        <Route exact path='/wallet' element={<WalletPage />} />
        <Route exact path='/widgets' element={<WidgetsPage />} />
        <Route exact path='/wizard' element={<WizardPage />} />

        <Route exact path='*' element={<ErrorPage />} />
      </Routes>
    </>
  );
}

export default App;
